import { Fragment, useContext } from "react";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import { mainContext } from "../utils/WebContext";

const WebLayout = ({ children }) => {
  const { setDd } = useContext(mainContext);
  return (
    <Fragment>
      <div onClick={() => setDd(false)}>
        <Header />
        {children}
        <Footer />
      </div>
    </Fragment>
  );
};
export default WebLayout;
